
import { Contact } from '@/models/contact';
import ContactItem from '@/components/contacts/ContactItem.vue';

export default {
    components: {
        ContactItem
    },
    inject: ['showCreateContact', 'showEditContact', 'showDeleteContact'],
    data() {
        return {
            isLoading: false,
            expansedContact: null
        };
    },
    computed: {
        availableContacts() {
            const allContacts: Contact[] = this.$store.getters['contacts/contacts'];
            const sortedContacts = allContacts
                .slice()
                .sort((c1, c2) => (c1.name.toLowerCase() > c2.name.toLowerCase() ? 1 : -1));

            return sortedContacts;
        },
        filteredContacts(): Contact[] {
            if (this.searchQuery && this.searchQuery.trim()) {
                return this.availableContacts.filter((contact: Contact) => {
                    // для проверки номеров, содержащий дефис
                    const normalizedPhone = contact.phone.replace(/-/g, '');
                    const normalizedQuery = this.searchQuery.replace(/-/g, '');

                    const nameMatch = contact.name.toLowerCase().includes(this.searchQuery.toLowerCase());
                    const numberMatch = normalizedPhone.includes(normalizedQuery);

                    // поиск для российских номеров ("+7" и "8" - одно и то же)
                    let rusNumMatch = false;
                    if (this.searchQuery.startsWith('+7') && contact.phone.startsWith('8')) {
                        const contactPart = normalizedPhone.slice(1); // "8123..." -> "123..."
                        const queryPart = normalizedQuery.slice(2); // "+7123..." -> "123..."
                        rusNumMatch = contactPart.startsWith(queryPart);
                    } else if (this.searchQuery.startsWith('8') && contact.phone.startsWith('+7')) {
                        const contactPart = normalizedPhone.slice(2); // "+7123..." -> "123..."
                        const queryPart = normalizedQuery.slice(1); // "8123..." -> "123..."
                        rusNumMatch = contactPart.startsWith(queryPart);
                    }

                    return nameMatch || numberMatch || rusNumMatch;
                });
            }
            return this.availableContacts;
        },
        searchQuery() {
            return this.$store.getters['contacts/searchQuery'];
        }
    },
    methods: {
        createContact() {
            this.showCreateContact();
        },
        async addDefaultContacts() {
            this.isLoading = true;
            await this.$store.dispatch('contacts/setDefaultContacts');
            this.isLoading = false;
        },
        editContact(id: string) {
            this.showEditContact(id);
        },
        deleteContact(id: string) {
            this.showDeleteContact(id);
        },
        getFirstLater(name: string) {
            return name[0].toUpperCase();
        },
        async loadContacts() {
            this.isLoading = true;
            try {
                const message = await this.$store.dispatch('contacts/loadContacts');
                this.$store.dispatch('snackbar/showSnackbar', { message, type: 'success' });
            } catch (error) {
                this.$store.dispatch('snackbar/showSnackbar', { message: error.message, type: 'failure' });
            }
            this.isLoading = false;
        }
    },
    created() {
        this.loadContacts();
    },
    watch: {
        availableContacts(newValue, oldValue) {
            if (newValue.length !== oldValue.length) this.expansedContact = null;
        }
    }
};
